<template>

    <v-flex>


        <generic-popup-response-status :success="false"
                                       :showPopup="showErrorPopup"
                                       @hidePopup="hideBaseErrorPopup()">
            <div v-for="error in baseErrors">
                <div>{{error}}</div>
            </div>
        </generic-popup-response-status>


        <generic-popup-response-status :success="true"
                                       @hidePopup="hideSuccessPopup()"
                                       :showPopup="showSuccessPopup">
            <template #title>
                {{ successMessage.title }}
            </template>
            {{ successMessage.text}}
        </generic-popup-response-status>


        <v-layout justify-center>
            <v-form class="form-full-width" v-bind="$attrs" ref="form" lazy-validation>
                <slot></slot>
            </v-form>
        </v-layout>

    </v-flex>


</template>

<script>

    import BaseFormMessage from "./BaseFormMessage"
    import GenericPopupResponseStatus from "./genericPopupResponseStatus";

    export default {
        data: function () {
            return {
                showErrorPopup: false,
                showSuccessPopup: false
            }
        },
        props: {
            baseErrors: Array,
            successMessage: Object,
            translationsScope: String,

        },
        watch: {
            baseErrors() {
                this.showErrorPopup = this.baseErrors && this.baseErrors.length > 0
            },
            successMessage() {
                this.showSuccessPopup = this.successMessage.title !== undefined && this.successMessage.text !== undefined

            }
        },
        components: {
            GenericPopupResponseStatus,
            BaseFormMessage
        },
        methods: {
            $_assignFocusHandlerOnInputs() {
                this.$refs.form.inputs.forEach((input) => {
                    input.$on("focus", this.resetValidation)
                })

            },
            hideBaseErrorPopup() {
                this.showErrorPopup = false
            },
            hideSuccessPopup() {
                this.showSuccessPopup = false
            },
            resetValidation() {
                this.resetBaseErrors()
                this.$refs.form.resetValidation()
            },

            resetForm() {
                this.$refs.form.reset()
            }

        }
    }

</script>

<style scoped lang="scss">

    .form-full-width {
        max-width: 100%;
    }

</style>